Vendd.Scripts.load(function () {
    var $wrapper = $('.x-career-filters');

    if ($wrapper.length < 1)
        return;

    var url;

    $('.js-filter', $wrapper).each(function () {
        if (LhApp.Function.QueryString.getValueOf($(this).data('key'))) {
            $('.button-wrapper.clear', $wrapper).show();
        }
    });

    $(".js-submit", $wrapper).click(function () {
        url = window.location.href;
        $('.js-filter', $wrapper).each(function (index) {           
            if ($(this).val() > -1) {
                url = LhApp.Function.Url.setParameterValueOnUrl(url, $(this).data('key'), $(this).val());
            }
            else {
                url = LhApp.Function.Url.removeParameterFromUrl(url, $(this).data('key'));
            }
        });
        window.location.href = url;
    });

    $('.js-reset', $wrapper).click(function () {
        url = window.location.href;
        $('.js-filter', $wrapper).each(function (index) {
            url = LhApp.Function.Url.removeParameterFromUrl(url, $(this).data('key'));
        });
        window.location.href = url;
    });
    
});

